import styled from 'styled-components';

import { colors } from 'Constants';

const TitleHeader=styled.span`
color:#3477bc;// ${colors.textAccent};
font-size:2.5em;
font-weight:bold;
font-family:Arial, Helvetica, sans-serif ;
`

export default styled.h2`
color:#012169;// ${colors.textAccent};
font-size: 1.3em;
font-weight:bold;
`


const SubHeader=styled.div`
color:#081f65;// ${colors.textAccent};
font-weight:bold;
font-family:Arial, Helvetica, sans-serif ;
`

export {SubHeader,TitleHeader}